import { ThumbsUp } from '@liveauctioneers/hammer-ui-core/icons';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { MouseEvent } from 'react';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type HelpfulProps = {
    active: boolean;
    className?: string;
    count: number;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    submitted: boolean;
};

export const Helpful = ({ active, className, count, onClick, submitted }: HelpfulProps) => {
    const formatMessage = useAppFormatMessage();

    const icon = active ? <ThumbsUp style="fill" /> : <ThumbsUp />;

    if (submitted) {
        return (
            <div className={cn('inline-flex min-w-3xl items-center', className)}>
                <Loading />
            </div>
        );
    }

    return (
        <InlineButton
            className={className}
            disabled={submitted}
            onClick={onClick}
        >
            <div className="flex items-center gap-md">
                <div>{formatMessage(['review', 'helpful'])}</div>
                <div className="flex items-center gap-xs">
                    {icon} {count}
                </div>
            </div>
        </InlineButton>
    );
};
